var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 617.286,
    height: 589.32,
    viewBox: "0 0 617.286 589.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29816",
    "data-name": "Path 29816",
    d: "M-2845.67,4595.844c3.588-13.086,5.44-26.5-2.676-35.406-3.676-4.028-10.2-6.822-15.556-8.822-10.439-3.881-21.114-9.116-32.289-10.821-11.792-1.794-24.878-2.882-36.611-.324-7.469,1.617-14.439,4.617-21.114,7.881-8.94,4.353-15.321,7.264-18.2,16.232a152.653,152.653,0,0,0-6.2,30.377c-3.146,30.024,1.029,60.107.912,90.131,0,2.94.029,6.028,1.529,8.675,2.941,5.234,11,5.293,16.762,5.293l57.2-.088a113.427,113.427,0,0,1,21.438,2.147,13.711,13.711,0,0,0,14.645-6.646c2.853-4.763,3.058-10.322,3.382-15.673a295.618,295.618,0,0,1,10.2-61.813C-2850.639,4611.223-2847.846,4603.725-2845.67,4595.844Z",
    transform: "translate(2979.5 -4538.959)",
    fill: "#e8505b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708",
    transform: "translate(-743.714 -316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 589.604,
    height: 111.716,
    transform: "translate(743.714 793.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 589,
    height: 589,
    transform: "translate(1361 316) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_517",
    "data-name": "Ellipse 517",
    cx: 207.464,
    cy: 207.464,
    r: 207.464,
    transform: "translate(859.052 427.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29810",
    "data-name": "Path 29810",
    d: "M-2935.988,4334.15c-9.439,9.7-.882,33.464,14.174,30.024,16.174-3.705,13.762-28.906-.882-33.053C-2928.4,4329.5-2932.959,4331-2935.988,4334.15Z",
    transform: "translate(3951.307 -3731.366)",
    fill: "#c7d3de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29811",
    "data-name": "Path 29811",
    d: "M-2877.819,4208.4a26.82,26.82,0,0,1-12.733,7.293c-9.44,2.146-18.291-2-26.172-6.764-8.41-5.117-16.791-10.292-24.731-16.115-5.676-4.175-11.469-8.616-15-14.85-4.088-7.234-4.323-15.909-3.5-24,.559-5.5-2-10.439-3.117-15.7-2.206-10.233.059-22.291,9.586-28.172,4.882-3,9.969-2.559,15.086-.353,3.911,1.676,7.587,4.029,11.7,5.205,8.763,2.5,18.232-.941,26.819-2.706,6.205-1.264,13-1.94,19.114.088,6.823,2.293,10.057,7.263,13.763,13.027,3.176,4.94,8,8.646,11.851,13.027a23.008,23.008,0,0,1,4.969,20.879c-2.529,11.115-8.94,20.672-14.5,30.406C-2868.2,4195.987-2872.349,4203.1-2877.819,4208.4Z",
    transform: "translate(3968.184 -3574.295)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29812",
    "data-name": "Path 29812",
    d: "M-3085.048,4654.635c11.322-17.468,18.379-38.875,8.528-58.578-1-2-2.205-4.176-4.323-4.881-4.558-1.529-10.734.118-14.7,2.44-13.733,8.058-22.143,23.231-29.877,36.729-8.028,14.027-15,28.612-23.055,42.64-3.264,5.675-6.558,11.41-8.322,17.732-1.529,5.528-1.705,11.851.383,17.262,9.057,23.378,33.935-5.264,41.493-13.909A349.032,349.032,0,0,0-3085.048,4654.635Z",
    transform: "translate(4105.219 -3914.993)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29813",
    "data-name": "Path 29813",
    d: "M-2869.882,4293.311a14.555,14.555,0,0,1-4.234,3.176c-4.117,2.059-9.087,1.941-13.469.588a43.163,43.163,0,0,1-12.115-6.528c-10.175-7.2-22.761-16.7-28.818-27.759-3.735-6.823-6.5-14.851-2.941-22.291a20.756,20.756,0,0,1,16.438-11.792,3.156,3.156,0,0,1,1.735.177,3.686,3.686,0,0,1,1.323,1.44c2.588,4.235,4.617,8.822,7.763,12.675a45.72,45.72,0,0,0,12.263,10.115c7.469,4.529,15.644,7.881,22.673,13.057,5.058,3.735,5.2,12.175,3.97,18.026A18.807,18.807,0,0,1-2869.882,4293.311Z",
    transform: "translate(3946.485 -3659.503)",
    fill: "#061f33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651",
    transform: "translate(999.734 660.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29814",
    "data-name": "Path 29814",
    d: "M-2845.67,4595.844c3.588-13.086,5.44-26.5-2.676-35.406-3.676-4.028-10.2-6.822-15.556-8.822-10.439-3.881-21.114-9.116-32.289-10.821-11.792-1.794-24.878-2.882-36.611-.324-7.469,1.617-14.439,4.617-21.114,7.881-8.94,4.353-15.321,7.264-18.2,16.232a152.653,152.653,0,0,0-6.2,30.377c-3.146,30.024,1.029,60.107.912,90.131,0,2.94.029,6.028,1.529,8.675,2.941,5.234,11,5.293,16.762,5.293l57.2-.088a113.427,113.427,0,0,1,21.438,2.147,13.711,13.711,0,0,0,14.645-6.646c2.853-4.763,3.058-10.322,3.382-15.673a295.618,295.618,0,0,1,10.2-61.813C-2850.639,4611.223-2847.846,4603.725-2845.67,4595.844Z",
    transform: "translate(2979.5 -4538.959)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29815",
    "data-name": "Path 29815",
    d: "M-2800.62,4544.743c4.029-6.5,4.94-14.645-.323-20.909-2.411-2.881-6.7-3.175-10.351-3.264a91.755,91.755,0,0,0-21.408,2.176c-6.675,1.5-13.5,4.029-16.38,10.5a15.57,15.57,0,0,0,1.441,14.762,18.915,18.915,0,0,0,11.586,8.028c7.675,1.764,16.673,1.529,24.025-1.441A24.653,24.653,0,0,0-2800.62,4544.743Z",
    transform: "translate(2888.31 -4525.969)",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29817",
    "data-name": "Path 29817",
    d: "M-2948.978,4847.484c7.675,3.617,16.056,5.44,24.437,6.852,23.408,3.911,47.286,4.734,71.017,3.617,5.058-.235,10.557-.735,14.321-4.176,2.793-2.558,4.087-6.322,5.028-9.969,3.176-12.469,3.117-25.5,3.058-38.376-.059-10.027-.088-20.084-.147-30.112-.03-3.5,2.264-24.76-3.176-24.525a2.956,2.956,0,0,0-1.588.676c-2.706,1.94-4.087,5.175-5.352,8.263-3.97,9.646-7.293,25.084-15.527,31.847-8.675,7.087-18.644,10.381-29.142,13.792-18.2,5.911-38.522,8.469-53.932,20.585-2.558,2.029-5.028,4.264-7.381,6.5-2.147,2.029-5.087,4.117-6.352,6.94C-2955.8,4843.75-2952.683,4845.75-2948.978,4847.484Z",
    transform: "translate(2961.769 -4688.5)",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29819",
    "data-name": "Path 29819",
    d: "M-2567.875,4659.426c2.882,5.234,5.764,10.469,8.587,15.732,5.734,10.675,16.379,34.436-.676,40.287-8.587,2.941-13.5.059-19.173-6.2a362.716,362.716,0,0,1-54.314-78.663c-5.411-10.586-19.732-38.2-2.323-44.521a21.16,21.16,0,0,1,17,1.235,33.765,33.765,0,0,1,6.44,4.764c12.586,11.2,21.526,25.672,29.495,40.346C-2577.9,4641.458-2572.874,4650.428-2567.875,4659.426Z",
    transform: "translate(3742.49 -3910.933)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29820",
    "data-name": "Path 29820",
    d: "M-2734.5,4938.748c1.5-.265,3-.5,4.5-.735,7.322-1.146,14.615-2.47,21.849-4.028a367.632,367.632,0,0,1,43.4-7.087c1.559-.147,3.088-.265,4.646-.383,6.558-.5,13.409-.676,19.408,2.382s10.733,10.292,9.263,17.262c-1.029,4.911-4.882,8.617-9.146,10.469-4.264,1.882-8.969,2.205-13.556,2.5q-22.364,1.5-44.757,3.029-11.072.75-22.143,1.529c-7.058.5-14.2,1.47-21.29,1.47-3,0-6.323-.529-8.852-2.5-3.5-2.706-5.587-8.469-5.911-13-.176-2.353.294-5.176,2.147-6.646a7.469,7.469,0,0,1,3.441-1.235C-2745.791,4940.777-2740.144,4939.719-2734.5,4938.748Z",
    transform: "translate(3822.247 -4151.938)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 70.723,
    height: 13.851,
    transform: "translate(959.27 792.104)",
    fill: "#414d53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29821",
    "data-name": "Path 29821",
    d: "M-3438.65,4763.383l-17.85-90.867a5.105,5.105,0,0,0-5.029-4.117h-118.656a5.121,5.121,0,0,0-4.117,2.117l-.03-.03-5.47,6.47,4.852-1.059,17.585,89.485a5.131,5.131,0,0,0,5.029,4.146h118.656A5.183,5.183,0,0,0-3438.65,4763.383Z",
    transform: "translate(4410.064 -3969.927)",
    fill: "#414d53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29822",
    "data-name": "Path 29822",
    d: "M-3570.054,4791.2H-3451.4a5.122,5.122,0,0,0,5.029-6.116l-17.85-90.867a5.1,5.1,0,0,0-5.028-4.117H-3587.9a5.122,5.122,0,0,0-5.028,6.117l17.85,90.867A5.158,5.158,0,0,0-3570.054,4791.2Z",
    transform: "translate(4412.344 -3985.246)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29823",
    "data-name": "Path 29823",
    d: "M-3388.328,4827.686a13.843,13.843,0,0,0,13.086,11.086c6.146,0,10.145-4.969,8.969-11.086s-7.028-11.086-13.086-11.086S-3389.417,4821.569-3388.328,4827.686Z",
    transform: "translate(4267.965 -4074.546)",
    fill: "#c7d3de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29824",
    "data-name": "Path 29824",
    d: "M-3593,4704.4",
    transform: "translate(4412.324 -3995.341)",
    fill: "#3f91ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29825",
    "data-name": "Path 29825",
    d: "M-2884.175,4998.26c-3.529.735-6.293,3.823-9.792,4.853a12.011,12.011,0,0,1-7.587-.559c-2.206-.823-4.47-1.265-6.734-2-1.764-.559-4.146-1.764-6.058-1.353-4.97,1.029-9.969,4.587-14.468,6.881a5.223,5.223,0,0,1-3.235.853c-1.117-.206-2.058-1.558-1.411-2.529-1.294,1.206-3.029,3.647-5.117,2.706a1.76,1.76,0,0,1-.912-2.323,7,7,0,0,1-2.47,2,2.409,2.409,0,0,1-2.882-.677,3,3,0,0,1-.383-1.44,10.935,10.935,0,0,1,1.147-5c3.558-7.764,11.616-13.527,18.438-18.144a14.817,14.817,0,0,1,3.852-2.088,14.474,14.474,0,0,1,3.882-.441,76.935,76.935,0,0,1,25.025,4.058c1.735.588,3.646.089,5.381-.235a8.692,8.692,0,0,1,3.882-.117,6.719,6.719,0,0,1,3.353,2.705,12.76,12.76,0,0,1,2.588,7.822c-.147,2.088-.294,4.323-2.764,4.764-1,.176-2.029.059-3.029.176A3.308,3.308,0,0,0-2884.175,4998.26Z",
    transform: "translate(3955.043 -4189.188)",
    fill: "#f8a17a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29826",
    "data-name": "Path 29826",
    d: "M-2806.162,4486.32c5.176-1.676,9.469-4.882,11.057-10.028,1.441-4.646-.824-9.881-1.235-14.586a90.332,90.332,0,0,1-.147-13.527c.265-4.176.676-8.5.03-12.645-.353-2.382-1.676-1.97-4.058-2.911a21.12,21.12,0,0,0-7.7-.941c-5.352,0-19.261-.382-22.555,4.323-1.529,2.146-1.647,4.852-1.706,7.41-.088,3.088-.647,7.087-1.147,11.41-.235,1.912-.088,3.823-.382,5.734a36.087,36.087,0,0,1-1.853,6.234c-2.676,7.733-.176,15.085,8.2,18.644A33.219,33.219,0,0,0-2806.162,4486.32Z",
    transform: "translate(3878.559 -3802.815)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29827",
    "data-name": "Path 29827",
    d: "M-2792.824,4435.534c-.353-2.382-1.676-1.97-4.058-2.911a21.12,21.12,0,0,0-7.7-.941c-5.352,0-19.261-.382-22.555,4.323-1.529,2.146-1.647,4.852-1.706,7.41-.088,3.088-.647,7.087-1.147,11.41-.235,1.912-.088,3.823-.382,5.734a30.152,30.152,0,0,1-1.323,4.764,28.4,28.4,0,0,0,16.409,1.029c9.734-2.382,17.085-8.44,22.349-16.32.03-.618.059-1.235.088-1.823C-2792.589,4444.033-2792.207,4439.681-2792.824,4435.534Z",
    transform: "translate(3874.896 -3802.815)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29828",
    "data-name": "Path 29828",
    d: "M-2843.65,4239.525a65.193,65.193,0,0,0-2.853-19.5c-7.91-24.231-38.14-30.23-56.343-12.821-20.291,19.408-12.527,65.783,8.852,82.074a24.051,24.051,0,0,0,20.438,4.028C-2852.56,4287.664-2843.5,4261.816-2843.65,4239.525Z",
    transform: "translate(3933.457 -3637.301)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29829",
    "data-name": "Path 29829",
    d: "M-2832.134,4220.028c-7.91-24.231-38.14-30.23-56.343-12.821a33.214,33.214,0,0,0-5.823,7.558,22.662,22.662,0,0,0,3.205,2.294,91.819,91.819,0,0,0,24.672,10.321c3.735.971,7.646,1.735,10.7,4.088a15.794,15.794,0,0,1,4.146,5,45.188,45.188,0,0,1,3.058,7.411c1.882,5.5,2.706,11.292,3.47,17.027a2.7,2.7,0,0,0,.618,1.646,2.348,2.348,0,0,0,1.618.47c3.352-.088,4.969-3.293,7.587-5,1.559-1.029,3.146-2.059,4.617-3.205a82.094,82.094,0,0,0,1.353-15.292A66.125,66.125,0,0,0-2832.134,4220.028Z",
    transform: "translate(3919.088 -3637.3)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29830",
    "data-name": "Path 29830",
    d: "M-2840.336,4216.6a46.482,46.482,0,0,1,2.088,7.763,87.887,87.887,0,0,1,1.235,17.35,2.732,2.732,0,0,0,.412,1.735,2.2,2.2,0,0,0,1.529.647c3.323.353,5.352-2.617,8.175-3.97a45.811,45.811,0,0,0,8.41-4.822c7.234-5.675,5.587-15.056,5.352-23.378-.118-4.587-.265-9.233-1.617-13.586a33.881,33.881,0,0,0-7.7-12.7c-9.792-10.586-24.614-16.085-38.935-15.174-7.087.441-15.086,3.44-20.144,8.557-4.352,4.411.941,10.38,4.529,13.233a92.4,92.4,0,0,0,23.143,13.438c3.558,1.441,7.352,2.735,10.086,5.44A14.91,14.91,0,0,1-2840.336,4216.6Z",
    transform: "translate(3911.234 -3618.35)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29831",
    "data-name": "Path 29831",
    d: "M-2703.176,4340.41c9.293-5.087,12.175,7.793,10.557,14.2a20.162,20.162,0,0,1-3.352,7.411c-2.206,2.941-8.528,7.793-12.175,4.588-1.647-1.47-1.823-3.941-1.882-6.146C-2710.145,4354.555-2709.469,4343.851-2703.176,4340.41Z",
    transform: "translate(3789.012 -3737.568)",
    fill: "#f8a17a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654",
    transform: "translate(1212.025 686.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29832",
    "data-name": "Path 29832",
    d: "M-2249.386,4693.036a10.66,10.66,0,0,0,.235-8.117,31.149,31.149,0,0,0-3.734-7.381,33.24,33.24,0,0,1-4.088-8.322,17.935,17.935,0,0,1,.206-9.969c1.941-6.293,5.94-10.91,8.7-15.645a22.08,22.08,0,0,0,2.94-7.528,13.01,13.01,0,0,0-.97-8.175,11.861,11.861,0,0,1,3.529,8.322,21.268,21.268,0,0,1-1.853,9.175c-2.382,5.7-5.969,10.322-7.352,15.35a13.449,13.449,0,0,0-.412,7.292c.47,2.47,1.764,4.941,2.911,7.646a26.616,26.616,0,0,1,2.676,8.792C-2246.357,4687.537-2247.063,4691.007-2249.386,4693.036Z",
    transform: "translate(2257.587 -4627.9)",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29833",
    "data-name": "Path 29833",
    d: "M-2257.593,4911.621h-20.555a7.354,7.354,0,0,1-7.352-7.352V4861.1h35.259v43.168A7.335,7.335,0,0,1-2257.593,4911.621Z",
    transform: "translate(3489.316 -4105.96)",
    fill: "#9ac4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29834",
    "data-name": "Path 29834",
    d: "M-2193.979,4900a15.431,15.431,0,0,0-15.321,15.526,15.412,15.412,0,0,0,15.321,15.527,15.431,15.431,0,0,0,15.321-15.527A15.412,15.412,0,0,0-2193.979,4900Zm0,25.525a9.922,9.922,0,0,1-9.851-10,9.921,9.921,0,0,1,9.851-10,9.922,9.922,0,0,1,9.851,10A9.922,9.922,0,0,1-2193.979,4925.525Z",
    transform: "translate(3435.524 -4133.421)",
    fill: "#9ac4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29835",
    "data-name": "Path 29835",
    d: "M-2272.089,4899.507h0A1.907,1.907,0,0,1-2274,4897.6v-24.584a1.907,1.907,0,0,1,1.911-1.911h0a1.907,1.907,0,0,1,1.911,1.911V4897.6A1.946,1.946,0,0,1-2272.089,4899.507Z",
    transform: "translate(3481.198 -4113.02)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29836",
    "data-name": "Path 29836",
    d: "M-2214.66,4861.1v41.581a8.935,8.935,0,0,1-8.939,8.94h8.146a8.935,8.935,0,0,0,8.939-8.94V4861.1Z",
    transform: "translate(3445.618 -4105.96)",
    fill: "#aecff9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29837",
    "data-name": "Path 29837",
    d: "M-2961.165,4147.074c-4-11.175-12-20.2-7.381-32.759a18.776,18.776,0,0,1,17.5-12.321,20.512,20.512,0,0,1,10.586,2.705c3.823,2.206,6.323,5.764,10.763,6.97,10.439,2.823,21.261-5.146,31.23-7,9.881-1.823,20.379,1.412,25.231,10.851,1.912,3.735,2.706,8.028,5.234,11.351,4.176,5.587,12.322,7.5,15.645,13.645,5.411,10.027-5.705,24.524-11.351,32.229",
    transform: "translate(3972.485 -3570.08)",
    fill: "none",
    stroke: "#0b2d4e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(1048.667 628.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29838",
    "data-name": "Path 29838",
    d: "M-2806.219,4446.385a49.272,49.272,0,0,1-6.881-.5l.412-2.794a42.541,42.541,0,0,0,24.084-3.352,31.928,31.928,0,0,0,5.205-3,24.329,24.329,0,0,0,6.734-7.439l2.441,1.411a27.42,27.42,0,0,1-7.528,8.293,34.3,34.3,0,0,1-5.675,3.264A44.325,44.325,0,0,1-2806.219,4446.385Z",
    transform: "translate(2813.1 -4429.3)",
    fill: "#c7d3de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659",
    transform: "translate(1038.93 637.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29839",
    "data-name": "Path 29839",
    d: "M-2844.619,4463.663c3.411-2.911,10.969-2.676,13.468.353,1.853,2.235,1.294,5.087-.765,7-2.411,2.235-5.381,2.117-8.381,1.441C-2844.06,4471.632-2848.706,4467.191-2844.619,4463.663Z",
    transform: "translate(2846.209 -4461.606)",
    fill: "#c7d3de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29841",
    "data-name": "Path 29841",
    d: "M-2703.254,4329.758c-13.115,3.353-18.2,28.083-3.558,33.024,15.732,5.293,26.819-17.5,16.5-28.671C-2694.344,4329.758-2699.02,4328.67-2703.254,4329.758Z",
    transform: "translate(3793.002 -3730.591)",
    fill: "#c7d3de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29842",
    "data-name": "Path 29842",
    d: "M-2683.094,4341.278c-9.057,1.47-14.645,20.7-5.293,26,10.028,5.705,19.467-11.439,13.557-21.319C-2677.154,4342.1-2680.183,4340.808-2683.094,4341.278Z",
    transform: "translate(3777.135 -3738.936)",
    fill: "#c7d3de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    transform: "translate(1041.109 537.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29843",
    "data-name": "Path 29843",
    d: "M-2784.045,4183.242l-3.5-.412c2.382-20.526,1.353-46.756-16.938-55.138-8.675-3.97-16.585-6.822-30.671-4.028a13.218,13.218,0,0,1-3.646-1.029c12.733-6.234,26.437-2.412,35.788,1.882C-2782.78,4133.75-2781.516,4161.54-2784.045,4183.242Z",
    transform: "translate(2838.8 -4119.358)",
    fill: "#b6c2cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1681",
    "data-name": "Group 1681",
    transform: "translate(-446 2779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29844",
    "data-name": "Path 29844",
    d: "M-2516.943,4053.02h120.362a12.111,12.111,0,0,0,12.057-12.057v-63.607a12.092,12.092,0,0,0-12.057-12.057h-120.362A12.073,12.073,0,0,0-2529,3977.356v63.607A12.092,12.092,0,0,0-2516.943,4053.02Z",
    transform: "translate(4135.211 -6252.585)",
    fill: "#9ac4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29845",
    "data-name": "Path 29845",
    d: "M-2464.3,4245.316V4205l31.553,17.232Z",
    transform: "translate(4089.537 -6421.798)",
    fill: "#9ac4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29846",
    "data-name": "Path 29846",
    d: "M-2385.33,4109.445h-66.224a2.636,2.636,0,0,1-2.647-2.646v-2.353a2.636,2.636,0,0,1,2.647-2.646h66.224a2.654,2.654,0,0,1,2.647,2.646v2.353A2.636,2.636,0,0,1-2385.33,4109.445Z",
    transform: "translate(4082.407 -6348.945)",
    fill: "#82baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29847",
    "data-name": "Path 29847",
    d: "M-2171.409,4109.445h-18.144a2.654,2.654,0,0,1-2.647-2.646v-2.353a2.654,2.654,0,0,1,2.647-2.646h18.144a2.654,2.654,0,0,1,2.647,2.646v2.353A2.654,2.654,0,0,1-2171.409,4109.445Z",
    transform: "translate(3897.453 -6348.945)",
    fill: "#82baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29848",
    "data-name": "Path 29848",
    d: "M-2353.053,4042.7h66.224a2.674,2.674,0,0,1,2.647,2.646v2.353a2.673,2.673,0,0,1-2.647,2.646h-66.224a2.674,2.674,0,0,1-2.647-2.646v-2.353A2.636,2.636,0,0,1-2353.053,4042.7Z",
    transform: "translate(4012.873 -6307.225)",
    fill: "#82baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29849",
    "data-name": "Path 29849",
    d: "M-2451.553,4042.7h18.144a2.674,2.674,0,0,1,2.646,2.646v2.353a2.673,2.673,0,0,1-2.646,2.646h-18.144a2.654,2.654,0,0,1-2.647-2.646v-2.353A2.654,2.654,0,0,1-2451.553,4042.7Z",
    transform: "translate(4082.407 -6307.225)",
    fill: "#82baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29850",
    "data-name": "Path 29850",
    d: "M-2406.62,4163.545h-44.933a2.636,2.636,0,0,1-2.647-2.646v-2.353a2.654,2.654,0,0,1,2.647-2.646h44.933a2.654,2.654,0,0,1,2.647,2.646v2.353A2.654,2.654,0,0,1-2406.62,4163.545Z",
    transform: "translate(4082.407 -6387.136)",
    fill: "#82baff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29871",
    "data-name": "Path 29871",
    d: "M-3121.654,5048.079h-508.765a9.169,9.169,0,0,1-9.381-8.939h0a9.17,9.17,0,0,1,9.381-8.939h508.765a9.169,9.169,0,0,1,9.381,8.939h0A9.132,9.132,0,0,1-3121.654,5048.079Z",
    transform: "translate(4417.361 -4225.334)",
    fill: "#c7d3de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378",
    transform: "translate(1118.571 689.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29017",
    "data-name": "Path 29017",
    d: "M706.771,275.449a2.033,2.033,0,0,0-.128-.609c-.128-.487-.257-1.1-.513-1.826-.385-1.582-1.026-3.9-1.54-6.816a86.917,86.917,0,0,1-1.668-10.225,51.193,51.193,0,0,1,0-12.537,30.832,30.832,0,0,1,4.491-11.685,54.4,54.4,0,0,1,6.415-8.277,59.839,59.839,0,0,1,5.261-4.869c1.283-1.1,2.053-1.582,2.053-1.7a6.752,6.752,0,0,0-.642.365q-.577.365-1.54,1.1a34.6,34.6,0,0,0-5.389,4.747,44.746,44.746,0,0,0-6.672,8.277,34.526,34.526,0,0,0-4.619,11.929,46.185,46.185,0,0,0,.128,12.659c.513,3.9,1.155,7.3,1.8,10.225s1.283,5.234,1.8,6.816a7.52,7.52,0,0,0,.641,1.826A1.415,1.415,0,0,0,706.771,275.449Z",
    transform: "translate(-701.9 -216.9)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    transform: "translate(1048.759 697.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29027",
    "data-name": "Path 29027",
    d: "M699.72,242.4s-.277.553-.968,1.659-1.659,2.627-2.766,4.425c-2.489,3.872-5.946,9.127-9.818,15.35l-.277-.553c3.319-.553,7.053-1.245,10.786-1.8,3.872-.691,7.468-1.245,10.925-1.8l.83-.138-.415.691c-4.01,6.085-7.606,11.2-10.1,15.073-1.245,1.8-2.213,3.181-2.9,4.287-.691.968-1.106,1.521-1.106,1.521s.277-.553.968-1.659,1.659-2.627,2.766-4.425c2.489-3.872,5.946-9.127,9.818-15.212l.277.553c-3.457.553-7.053,1.245-10.925,1.936-3.734.691-7.468,1.245-10.786,1.8l-.83.138.415-.691c4.01-6.085,7.468-11.34,10.095-15.212,1.245-1.8,2.213-3.319,2.9-4.287C699.305,242.953,699.72,242.4,699.72,242.4Z",
    transform: "translate(-685.2 -242.4)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1680",
    "data-name": "Group 1680",
    transform: "translate(1076.759 733.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29027-2",
    "data-name": "Path 29027",
    d: "M699.72,242.4s-.277.553-.968,1.659-1.659,2.627-2.766,4.425c-2.489,3.872-5.946,9.127-9.818,15.35l-.277-.553c3.319-.553,7.053-1.245,10.786-1.8,3.872-.691,7.468-1.245,10.925-1.8l.83-.138-.415.691c-4.01,6.085-7.606,11.2-10.1,15.073-1.245,1.8-2.213,3.181-2.9,4.287-.691.968-1.106,1.521-1.106,1.521s.277-.553.968-1.659,1.659-2.627,2.766-4.425c2.489-3.872,5.946-9.127,9.818-15.212l.277.553c-3.457.553-7.053,1.245-10.925,1.936-3.734.691-7.468,1.245-10.786,1.8l-.83.138.415-.691c4.01-6.085,7.468-11.34,10.095-15.212,1.245-1.8,2.213-3.319,2.9-4.287C699.305,242.953,699.72,242.4,699.72,242.4Z",
    transform: "translate(-685.2 -242.4)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1679",
    "data-name": "Group 1679",
    transform: "translate(1016.759 741.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29027-3",
    "data-name": "Path 29027",
    d: "M699.72,242.4s-.277.553-.968,1.659-1.659,2.627-2.766,4.425c-2.489,3.872-5.946,9.127-9.818,15.35l-.277-.553c3.319-.553,7.053-1.245,10.786-1.8,3.872-.691,7.468-1.245,10.925-1.8l.83-.138-.415.691c-4.01,6.085-7.606,11.2-10.1,15.073-1.245,1.8-2.213,3.181-2.9,4.287-.691.968-1.106,1.521-1.106,1.521s.277-.553.968-1.659,1.659-2.627,2.766-4.425c2.489-3.872,5.946-9.127,9.818-15.212l.277.553c-3.457.553-7.053,1.245-10.925,1.936-3.734.691-7.468,1.245-10.786,1.8l-.83.138.415-.691c4.01-6.085,7.468-11.34,10.095-15.212,1.245-1.8,2.213-3.319,2.9-4.287C699.305,242.953,699.72,242.4,699.72,242.4Z",
    transform: "translate(-685.2 -242.4)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(1141.496 780.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29031",
    "data-name": "Path 29031",
    d: "M694.272,282.2s-.691.138-1.936.277c-1.383.138-3.042.277-5.255.415-4.564.277-10.925.83-18.116,1.383l.277-.553c2.489,2.351,5.117,4.84,8.021,7.468,2.766,2.628,5.532,5.255,8.021,7.606l.553.553h-.83c-7.191.415-13.552.691-18.116.968-2.213.138-3.872.138-5.255.277H659.7s.691-.138,1.936-.277c1.383-.138,3.042-.277,5.255-.415,4.563-.277,10.786-.691,18.116-1.245l-.277.553c-2.489-2.351-5.255-4.978-8.021-7.606s-5.531-5.117-7.882-7.468l-.553-.553h.83c7.329-.415,13.552-.83,18.116-1.106,2.213-.138,3.872-.138,5.255-.277Z",
    transform: "translate(-659.7 -282.2)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675",
    transform: "translate(1127.496 732.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29031-2",
    "data-name": "Path 29031",
    d: "M694.272,282.2s-.691.138-1.936.277c-1.383.138-3.042.277-5.255.415-4.564.277-10.925.83-18.116,1.383l.277-.553c2.489,2.351,5.117,4.84,8.021,7.468,2.766,2.628,5.532,5.255,8.021,7.606l.553.553h-.83c-7.191.415-13.552.691-18.116.968-2.213.138-3.872.138-5.255.277H659.7s.691-.138,1.936-.277c1.383-.138,3.042-.277,5.255-.415,4.563-.277,10.786-.691,18.116-1.245l-.277.553c-2.489-2.351-5.255-4.978-8.021-7.606s-5.531-5.117-7.882-7.468l-.553-.553h.83c7.329-.415,13.552-.83,18.116-1.106,2.213-.138,3.872-.138,5.255-.277Z",
    transform: "translate(-659.7 -282.2)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1676",
    "data-name": "Group 1676",
    transform: "translate(1093.496 690.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29031-3",
    "data-name": "Path 29031",
    d: "M694.272,282.2s-.691.138-1.936.277c-1.383.138-3.042.277-5.255.415-4.564.277-10.925.83-18.116,1.383l.277-.553c2.489,2.351,5.117,4.84,8.021,7.468,2.766,2.628,5.532,5.255,8.021,7.606l.553.553h-.83c-7.191.415-13.552.691-18.116.968-2.213.138-3.872.138-5.255.277H659.7s.691-.138,1.936-.277c1.383-.138,3.042-.277,5.255-.415,4.563-.277,10.786-.691,18.116-1.245l-.277.553c-2.489-2.351-5.255-4.978-8.021-7.606s-5.531-5.117-7.882-7.468l-.553-.553h.83c7.329-.415,13.552-.83,18.116-1.106,2.213-.138,3.872-.138,5.255-.277Z",
    transform: "translate(-659.7 -282.2)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1677",
    "data-name": "Group 1677",
    transform: "translate(1009.496 690.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29031-4",
    "data-name": "Path 29031",
    d: "M694.272,282.2s-.691.138-1.936.277c-1.383.138-3.042.277-5.255.415-4.564.277-10.925.83-18.116,1.383l.277-.553c2.489,2.351,5.117,4.84,8.021,7.468,2.766,2.628,5.532,5.255,8.021,7.606l.553.553h-.83c-7.191.415-13.552.691-18.116.968-2.213.138-3.872.138-5.255.277H659.7s.691-.138,1.936-.277c1.383-.138,3.042-.277,5.255-.415,4.563-.277,10.786-.691,18.116-1.245l-.277.553c-2.489-2.351-5.255-4.978-8.021-7.606s-5.531-5.117-7.882-7.468l-.553-.553h.83c7.329-.415,13.552-.83,18.116-1.106,2.213-.138,3.872-.138,5.255-.277Z",
    transform: "translate(-659.7 -282.2)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1678",
    "data-name": "Group 1678",
    transform: "translate(965.496 738.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29031-5",
    "data-name": "Path 29031",
    d: "M694.272,282.2s-.691.138-1.936.277c-1.383.138-3.042.277-5.255.415-4.564.277-10.925.83-18.116,1.383l.277-.553c2.489,2.351,5.117,4.84,8.021,7.468,2.766,2.628,5.532,5.255,8.021,7.606l.553.553h-.83c-7.191.415-13.552.691-18.116.968-2.213.138-3.872.138-5.255.277H659.7s.691-.138,1.936-.277c1.383-.138,3.042-.277,5.255-.415,4.563-.277,10.786-.691,18.116-1.245l-.277.553c-2.489-2.351-5.255-4.978-8.021-7.606s-5.531-5.117-7.882-7.468l-.553-.553h.83c7.329-.415,13.552-.83,18.116-1.106,2.213-.138,3.872-.138,5.255-.277Z",
    transform: "translate(-659.7 -282.2)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29935",
    "data-name": "Path 29935",
    d: "M-2494.692,4453.247c-2.718-4.648-9.541-6.959-16.146.761-6.605-7.72-13.456-5.41-16.147-.761-6.687,11.417,16.147,24.873,16.147,24.873S-2488.032,4464.664-2494.692,4453.247Z",
    transform: "translate(3395.669 -3843.797)",
    fill: "#9ac4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29936",
    "data-name": "Path 29936",
    d: "M-2917.959,3942.52h-33.979a3.272,3.272,0,0,1-3.262-3.262v-20.5a3.272,3.272,0,0,1,3.262-3.262h33.979a3.271,3.271,0,0,1,3.262,3.262v20.5A3.272,3.272,0,0,1-2917.959,3942.52Z",
    transform: "translate(3867.589 -3427.339)",
    fill: "#9ac4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29937",
    "data-name": "Path 29937",
    d: "M-2952.8,3918.7l17.723,17.18a2.729,2.729,0,0,0,3.724,0l17.723-17.18",
    transform: "translate(3865.842 -3429.669)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 11.172,
    x2: 14.543,
    transform: "translate(913.041 503.139)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 14.57,
    y1: 11.172,
    transform: "translate(937.669 503.139)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1704",
    "data-name": "Group 1704",
    transform: "translate(1052.228 431.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29938",
    "data-name": "Path 29938",
    d: "M-3188.18,4315.784h-40.258a3.272,3.272,0,0,1-3.262-3.262v-25.959a3.271,3.271,0,0,1,3.262-3.262h40.258a3.271,3.271,0,0,1,3.262,3.262v25.959A3.272,3.272,0,0,1-3188.18,4315.784Z",
    transform: "translate(3231.7 -4283.3)",
    fill: "#9ac4f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1705",
    "data-name": "Group 1705",
    transform: "translate(1067.423 462.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29939",
    "data-name": "Path 29939",
    d: "M-3167.591,4410.936l8.182-11.036H-3175.8Z",
    transform: "translate(3175.8 -4399.9)",
    fill: "#9ac4f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    "data-name": "Group 1706",
    transform: "translate(1083.19 441.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29940",
    "data-name": "Path 29940",
    d: "M-3113.07,4332.768h-2.012v-5.545l.027-.9.027-1.006a9.554,9.554,0,0,1-.707.652l-1.087.9-.979-1.223,3.072-2.446h1.658Z",
    transform: "translate(3117.8 -4323.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707",
    transform: "translate(1061.171 441.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29941",
    "data-name": "Path 29941",
    d: "M-3187.03,4322h-6.633a5.151,5.151,0,0,0-5.138,5.138h0a5.15,5.15,0,0,0,2.229,4.213v3.615l3.7-2.691h5.844a5.151,5.151,0,0,0,5.137-5.137h0A5.186,5.186,0,0,0-3187.03,4322Z",
    transform: "translate(3198.8 -4322)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.d7c2eb5a35c9024ef7882104aba09057.svg";
export { ForwardRef as ReactComponent };